import React from 'react';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import ImageIcon from '@mui/icons-material/Image';
import DescriptionIcon from '@mui/icons-material/Description';
import AudioFileIcon from '@mui/icons-material/Audiotrack';
import VideoFileIcon from '@mui/icons-material/VideoFile';
import TableChartIcon from '@mui/icons-material/TableChart';
import ArchiveIcon from '@mui/icons-material/Inventory2';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';

const extensionMatches = (fileName = '', extensions = []) => {
  const ext = fileName.split('.').pop();
  if (!ext) {
    return false;
  }
  return extensions.indexOf(ext.toLowerCase()) >= 0;
};

export const getFileIcon = (fileName) => {
  if (extensionMatches(fileName, ['pdf'])) {
    return <PictureAsPdfIcon fontSize="small" />;
  }
  if (extensionMatches(fileName, ['png', 'jpg', 'jpeg', 'gif', 'bmp', 'svg', 'webp'])) {
    return <ImageIcon fontSize="small" />;
  }
  if (extensionMatches(fileName, ['xls', 'xlsx', 'csv', 'numbers'])) {
    return <TableChartIcon fontSize="small" />;
  }
  if (extensionMatches(fileName, ['doc', 'docx', 'txt', 'rtf', 'pages'])) {
    return <DescriptionIcon fontSize="small" />;
  }
  if (extensionMatches(fileName, ['mp3', 'wav', 'aac', 'flac', 'm4a'])) {
    return <AudioFileIcon fontSize="small" />;
  }
  if (extensionMatches(fileName, ['mp4', 'mov', 'avi', 'mkv'])) {
    return <VideoFileIcon fontSize="small" />;
  }
  if (extensionMatches(fileName, ['zip', 'rar', '7z', 'tar', 'gz'])) {
    return <ArchiveIcon fontSize="small" />;
  }
  return <InsertDriveFileIcon fontSize="small" />;
};
